import { render, staticRenderFns } from "./LaserStatusDialog.vue?vue&type=template&id=56baabbf&scoped=true"
import script from "./LaserStatusDialog.vue?vue&type=script&lang=js"
export * from "./LaserStatusDialog.vue?vue&type=script&lang=js"
import style0 from "./LaserStatusDialog.vue?vue&type=style&index=0&id=56baabbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56baabbf",
  null
  
)

export default component.exports